import { useEffect } from "react";
import {
    Box,
    Flex,
    Text,
    VStack,
} from "@chakra-ui/react";

import {
    useDispatch,
} from "react-redux";

import {
    fetchMySupportTickets,
} from "../../state/actions/supportActions";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";

import SupportHeader from "./components/SupportHeader";
import QuickActions from "./components/QuickActions";
import KnowledgeBaseGrid from "./components/KnowledgeBaseGrid";
import TicketsTable from "./components/TicketsTable";
import Footer from "./components/Footer";

const Support = () => {
    const dispatch =
        useDispatch();

    useEffect(() => {
        dispatch(
            fetchMySupportTickets(
                1,
                10
            )
        );
    }, [dispatch]);

    return (
        <Flex
            h="100vh"
            bg="#F8FAFC"
            overflow="hidden"
        >
            {/* Sidebar */}

            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            {/* Main Content */}

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
                minW={0}
            >
                <Topbar />

                {/* Scrollable Area */}

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 6,
                        lg: 8,
                    }}
                >
                    <SupportHeader />

                    <VStack
                        align="stretch"
                        gap={{
                            base: 5,
                            md: 6,
                        }}
                        mt={6}
                    >
                        <QuickActions />

                        <Box>
                            <Text
                                fontSize="xs"
                                color="gray.400"
                                fontWeight="700"
                                letterSpacing="2px"
                                mb={4}
                            >
                                KNOWLEDGE BASE
                                CATEGORIES
                            </Text>

                            <KnowledgeBaseGrid />
                        </Box>

                        <TicketsTable />

                        <Footer />
                    </VStack>
                </Box>
            </Flex>
        </Flex>
    );
};

export default Support;